export default __webpack_public_path__ + "static/media/card_3@3x.b306dfed.png";